import React from 'react';
import PropTypes from 'prop-types';
import {ButtonGroup, Modal} from '@/components/atoms';
import {MODAL_TYPE} from '@/utils/constants/globalStyle';

const BUTTON_LABELS = {
  UNPUBLISH: 'Unpublish',
  PUBLISH: 'Publish',
  DUPLICATE: 'Duplicate',
  DOWNLOAD: 'Download'
};

const SurveyActionButtons = ({surveyActions}) => {
  const {
    shouldShowUnpublishButton,
    shouldShowPublishButton,
    isPublishEnabled,
    isDuplicateEnabled,
    isDownloadEnabled,
    showUnpublishModal,
    showPublishModal,
    handleUnpublishClick,
    handlePublishClick,
    handleCloseUnpublishModal,
    handleClosePublishModal,
    handleConfirmUnpublish,
    handleConfirmPublish,
    handleDuplicate,
    handleDownload
  } = surveyActions;

  const buttonItems = [];

  if (shouldShowUnpublishButton) {
    buttonItems.push({
      icon: 'pause',
      label: BUTTON_LABELS.UNPUBLISH,
      onClick: handleUnpublishClick
    });
  }

  if (shouldShowPublishButton) {
    buttonItems.push({
      icon: 'refresh',
      label: BUTTON_LABELS.PUBLISH,
      onClick: handlePublishClick,
      disabled: !isPublishEnabled
    });
  }

  buttonItems.push(
    {
      icon: 'content_copy',
      label: BUTTON_LABELS.DUPLICATE,
      onClick: handleDuplicate,
      disabled: !isDuplicateEnabled
    },
    {
      icon: 'download',
      label: BUTTON_LABELS.DOWNLOAD,
      onClick: handleDownload,
      disabled: !isDownloadEnabled
    }
  );

  return (
    <>
      <ButtonGroup
        uiSchema={{items: buttonItems}}
        isDark
        id='survey-review-action-buttons'
      />

      {showUnpublishModal && (
        <Modal
          type={MODAL_TYPE.FLUID}
          showModal={showUnpublishModal}
          onCloseModal={handleCloseUnpublishModal}
          title='Unpublish Survey'
          text='This Survey will be unpublished and will remain so until it is manually reactivated. Are you sure you want to proceed?'
          showPrimaryButton={true}
          primaryButtonText='Continue'
          onClickPrimaryButton={handleConfirmUnpublish}
          showSecondaryButton={true}
          secondaryButtonText='Cancel'
          onClickSecondaryButton={handleCloseUnpublishModal}
          footerProps={{size: 'medium', type: 'primary'}}
          isDark={true}
        />
      )}

      {showPublishModal && (
        <Modal
          type={MODAL_TYPE.FLUID}
          showModal={showPublishModal}
          onCloseModal={handleClosePublishModal}
          title='Publish Survey'
          text='This Survey will be published immediately. Are you sure you want to continue?'
          showPrimaryButton={true}
          primaryButtonText='Continue'
          onClickPrimaryButton={handleConfirmPublish}
          showSecondaryButton={true}
          secondaryButtonText='Cancel'
          onClickSecondaryButton={handleClosePublishModal}
          footerProps={{size: 'medium', type: 'primary'}}
          isDark={true}
        />
      )}
    </>
  );
};

SurveyActionButtons.propTypes = {
  surveyActions: PropTypes.shape({
    shouldShowUnpublishButton: PropTypes.bool,
    shouldShowPublishButton: PropTypes.bool,
    isPublishEnabled: PropTypes.bool,
    isDuplicateEnabled: PropTypes.bool,
    isDownloadEnabled: PropTypes.bool,
    showUnpublishModal: PropTypes.bool,
    showPublishModal: PropTypes.bool,
    handleUnpublishClick: PropTypes.func,
    handlePublishClick: PropTypes.func,
    handleCloseUnpublishModal: PropTypes.func,
    handleClosePublishModal: PropTypes.func,
    handleConfirmUnpublish: PropTypes.func,
    handleConfirmPublish: PropTypes.func,
    handleDuplicate: PropTypes.func,
    handleDownload: PropTypes.func
  }).isRequired
};

export default SurveyActionButtons;
